import React, { Component } from "react";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonMenu,
  IonItem,
  IonList,
  IonMenuButton,
  IonButtons,
  IonButton,
  IonInput,
  IonSelect,
  IonSelectOption,
  IonModal,
  IonBackButton,
} from "@ionic/react";
import { RouteComponentProps, withRouter } from "react-router";

import { format } from "date-fns";

// CSS
import "./NotificationsListPage.css";
import "../../Shared.css";
import "../../../App.css";

// Images
import iconClearSearch from "../../assets/Button_Cancel@3x.png";
import disclosureRight from "../../assets/Button_Disclosure_Right_Grey50@3x.png";

// Controllers
import { IScreenProps, IUser, IGuideline, IAlgorithm, IPatientAge, INotification } from "../../Interfaces";
import AppController from "../../../controllers/AppController";
import DataController from "../../controllers/DataController";

// Components
import AppCard from "../../components/AppCard";

import _ from "lodash";

type Props = RouteComponentProps<{ id: string; tab: string }> & { screenProps: IScreenProps; features: string[] };
type State = {
  previousNotificationsLastReadTime: number;
};

class NotificationsListPage extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      previousNotificationsLastReadTime: 0,
    };
  }

  async componentDidMount() {
    let previousNotificationsLastReadTime = await DataController.getNotificationsLastReadTime();
    this.setState({ previousNotificationsLastReadTime });
    this.props.screenProps.markNotificationsAsRead();
  }

  notificationClicked(notification: INotification) {
    this.props.screenProps.notificationClicked(notification);
  }

  render() {
    let notificationCells: any = [];

    // render significant changes
    for (
      let notificationIndex = 0;
      notificationIndex < this.props.screenProps.notifications.length;
      notificationIndex++
    ) {
      let notification = this.props.screenProps.notifications[notificationIndex];

      let isNew = notification.date != null && notification.date > this.state.previousNotificationsLastReadTime;

      let notificationTrustSection = "";
      if (notification.trust != null) {
        notificationTrustSection = DataController.getSectionClass(notification.trust);
      }

      notificationCells.push(
        <div
          className="notificationCell globalContentOnlyWideMargin"
          key={notification.id}
          onClick={this.notificationClicked.bind(this, notification)}
        >
          <div className="notificationCellBody">
            <div className="notificationCellInfoLine">
              {isNew ? <div className="notificationCellNewLabel">New</div> : null}
              {notification.trust != null && notification.trust !== "" ? (
                <div className={`notificationCellTrust ${notificationTrustSection}`}>{notification.trust}</div>
              ) : null}
            </div>
            <div className="notificationCellTitle">
              {notification.title}
              {notification.contents ? (
                <span className="notificationCellContent"> - {notification.contents}</span>
              ) : null}
            </div>
            {notification.date ? (
              <div className="notificationCellDate">{format(notification.date, "dd MMM yyyy HH:mm")}</div>
            ) : null}
          </div>
          <div className="notificationCellDisclosure">
            {notification.data != null ? <img alt="" src={disclosureRight} className="icon-44" /> : null}
          </div>
        </div>
      );
    }

    let emptyNotificationsLayout = null;

    if (notificationCells.length <= 0) {
      emptyNotificationsLayout = (
        <div className="emptyNotifications">You’re up to date. Any future notifications will appear here.</div>
      );
    }

    return (
      <IonPage>
        <IonHeader>
          <IonToolbar mode="ios" className="navBar">
            <IonButtons slot="start" className="headerButtonText" color="#FFFFFF">
              <IonBackButton defaultHref={`/${this.props.match.params.tab}`} class="headerButtonText" />
            </IonButtons>
            <IonTitle>Notifications</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen>
          <div className="dashboardContentContainer">
            {notificationCells}
            {emptyNotificationsLayout}
          </div>
        </IonContent>
      </IonPage>
    );
  }
}

export default withRouter(NotificationsListPage);
